import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { Icon } from '@/assets/icons/LibrarySvg';
import Tooltip from '@/components/Common/Tooltip';
import { tileButton } from '../commonToolbarStyles';
/**
 * Кнопка для открытия попапа редактирования фильтров изображения.
 */
export const ImageFiltersButton = ({ element, onOpenFilters, buttonRef, }) => {
    var _a;
    const internalRef = useRef(null);
    const ref = buttonRef || internalRef;
    const hasFilters = ((_a = element.props) === null || _a === void 0 ? void 0 : _a.filters) &&
        (element.props.filters.brightness !== undefined ||
            element.props.filters.contrast !== undefined ||
            element.props.filters.opacity !== undefined);
    return (_jsx("div", { className: "image-filters-button-container", children: _jsx(Tooltip, { text: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F", position: "top", children: _jsx("button", { ref: ref, type: "button", onClick: onOpenFilters, style: tileButton(hasFilters !== null && hasFilters !== void 0 ? hasFilters : false, { padding: '8px 14px' }), "aria-pressed": hasFilters !== null && hasFilters !== void 0 ? hasFilters : false, "aria-label": "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F", tabIndex: 0, children: _jsx(Icon, { name: "filters_1" }) }) }) }));
};
